import styles from "@styles/Interaction.module.css";
import { createContext, Dispatch, PropsWithChildren, SetStateAction, useContext, useEffect, useState } from "react";
import { LoadingContext } from "@components/Loader";
import { Interaction as Icon } from "@components/Icons";

export type InteractContextProps = {
    interacted: boolean;
    setInteracted: Dispatch<SetStateAction<boolean>>;
}
export const interactContext: InteractContextProps = {
    interacted: false,
    setInteracted: undefined!
}
export const InteractContext = createContext(interactContext);

export function Interaction({ children }: PropsWithChildren) {
    const [interacted, setInteracted] = useState(false);

    const { loaded } = useContext(LoadingContext);
    const [opacity, setOpacity] = useState(0);

    useEffect(() => {
        let timeout: NodeJS.Timeout;
        if (loaded) timeout = setTimeout(() => {
            setInteracted(false);
            setOpacity(1);
        }, 2100);
        return () => clearTimeout(timeout);
    }, [loaded]);

    useEffect(() => {
        if (interacted) setOpacity(0);
    }, [interacted, setOpacity]);

    return (
        <InteractContext.Provider value={{ interacted, setInteracted }}>
            {children}
            <div className={styles.center}>
                <div className={styles.interact} style={{ opacity }}>
                    <Icon loop autoplay color="var(--color-main)" />
                </div>
            </div>
        </InteractContext.Provider>
    );
}